import Cookies from 'cookies-js'
import { IS_AUTHORIZED } from 'constant'

// You have to be careful when using this helper because it's always returns undefined on server rendering
export default () =>
  Cookies.get && Cookies.get(IS_AUTHORIZED) === 'true'
